// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--Sbe6Q","icon":"icon--URHL7","mobile":"mobile--RpzE9"};